"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTREngine = void 0;
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var image_processor_1 = __importDefault(require("./image.processor"));
var text_processor_1 = __importDefault(require("./text.processor"));
var svg_engine_1 = require("./svg.engine");
var RTR_TYPE_IMAGE = "image";
var RTR_TYPE_TEXT = "text";
var RTREngine = /** @class */ (function () {
    function RTREngine() {
    }
    RTREngine.prototype.setup = function () {
        this.processors = new Map();
        this.setupCommonProcessors();
        this.defs = [];
        // TODO: Add support for custom fonts
    };
    RTREngine.prototype.addDefs = function (def) {
        this.defs.push(def);
    };
    RTREngine.prototype.setupCommonProcessors = function () {
        this.processors.set(RTR_TYPE_IMAGE, image_processor_1.default);
        this.processors.set(RTR_TYPE_TEXT, text_processor_1.default);
    };
    RTREngine.prototype.render = function (layers, data, finalWidth, finalHeight, debug) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, width, height, svg, _i, _b, def, orderedLayers, _c, orderedLayers_1, step, type, p, error_1, error_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (debug)
                            console.log("[RTR]: Starting RTR: ");
                        _a = layers[0], width = _a.width, height = _a.height;
                        svg = svg_engine_1.SVGEngine.getNode("svg", {
                            width: finalWidth,
                            height: finalHeight,
                            viewBox: "0 0 ".concat(width, " ").concat(height),
                        });
                        for (_i = 0, _b = this.defs; _i < _b.length; _i++) {
                            def = _b[_i];
                            svg.appendChild(new DOMParser().parseFromString(def, "application/xml").children[0]);
                        }
                        orderedLayers = (0, orderBy_1.default)(layers, "positionZ", "asc");
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, , 9]);
                        _c = 0, orderedLayers_1 = orderedLayers;
                        _d.label = 2;
                    case 2:
                        if (!(_c < orderedLayers_1.length)) return [3 /*break*/, 7];
                        step = orderedLayers_1[_c];
                        type = step.type;
                        if (!this.processors.has(type)) {
                            console.log("RTR processor not available for type ".concat(type));
                            return [3 /*break*/, 6];
                        }
                        p = this.processors.get(type);
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, p(svg, step, data, debug)];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _d.sent();
                        console.log("Error while processing layer: ", step);
                        console.error(error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        _c++;
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_2 = _d.sent();
                        console.log(error_2);
                        console.error(error_2);
                        return [3 /*break*/, 9];
                    case 9:
                        // Fix Safari/Firefox/Chromium bug where they neex all href to be at same id
                        // Removes ns1:href, ns2:href... and replaces with xlink:href
                        svg.innerHTML = svg.innerHTML.replace(/NS\d+:href/gi, 'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');
                        return [2 /*return*/, svg];
                }
            });
        });
    };
    return RTREngine;
}());
exports.RTREngine = RTREngine;
